import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'staging',
  appClientId: '3jgp177ui62ul69q8j5h1kcnsv',
  region: 'us-west-2',
  identityPoolId: 'us-west-2:7e497c92-72ec-4798-ba52-e8d81e54c643',
  userPoolId: 'us-west-2_MKXseVXwk',
  domain: 'drift-test.auth.us-west-2.amazoncognito.com',
  driftApi: 'https://fa76h2eglj.execute-api.us-west-2.amazonaws.com',
  redirectSignIn: 'https://test.drift.slalom.com/home',
  redirectSignOut: 'https://test.drift.slalom.com/home',
  features: {
    enablePersonasManagement: true,
    enableSystemPrompts: true,
    enableReviewers: true,
    enableNewAdvisor: true,
    enableOldAdvisor: false,
    enableSampleStyles: false,
    enableLibrary: true
  },
  enableMocks: false
};
